import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Download, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VIDEO_URL = `${API}/walkthrough.mp4`;

const STEPS = [
  { time: "0:00", title: "Welcome to slang.dex", note: "The Gen Z decoder — 230+ words" },
  { time: "0:05", title: "Speak fluent internet", note: "Browse · search · pronounce" },
  { time: "0:09", title: "Trending this week", note: "Fresh drops every week" },
  { time: "0:13", title: "Search any word", note: "Type and press SEARCH" },
  { time: "0:17", title: "Instant results", note: "Meaning · example · audio" },
  { time: "0:21", title: "Tap any card", note: "Big bold detail page" },
  { time: "0:25", title: "Hear it out loud", note: "Browser-native speech" },
  { time: "0:31", title: "Join the dex", note: "Free + 30-second signup" },
  { time: "0:35", title: "Drop a new word", note: "Word · meaning · example" },
  { time: "0:40", title: "Claude AI screens it", note: "Slurs · fakes · duplicates" },
  { time: "0:47", title: "Your submissions", note: "AI verdict + admin notes" },
  { time: "0:55", title: "That's slang.dex", note: "Made with vibes ✦" },
];

export default function Walkthrough() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-10">
      <Link data-testid="walkthrough-back-link" to="/" className="inline-flex items-center gap-2 font-mono-tag text-xs uppercase brutal-sm bg-white px-3 py-1.5 brutal-hover mb-6">
        <ArrowLeft className="h-3 w-3" strokeWidth={3} /> back to dex
      </Link>

      <div className="flex items-end flex-wrap gap-4 justify-between mb-6">
        <div>
          <span className="font-mono-tag text-xs uppercase bg-lime brutal-sm px-2 py-1 inline-block mb-3">
            <Sparkles className="inline h-3 w-3 mr-1 -mt-0.5" strokeWidth={3} /> 1:00 walkthrough · with voiceover
          </span>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tighter leading-none">
            See every feature<span className="text-hot">.</span>
          </h1>
          <p className="mt-3 max-w-xl">Quick guided tour through browsing, search, pronunciation, submitting words, AI screening, and the admin think tank.</p>
        </div>
        <a
          data-testid="download-walkthrough-link"
          href={VIDEO_URL}
          download="slangdex-walkthrough.mp4"
          className="bg-hot text-white font-display uppercase text-sm px-4 py-2 brutal-sm brutal-hover brutal-active inline-flex items-center gap-2"
        >
          <Download className="h-4 w-4" strokeWidth={3} /> Download MP4
        </a>
      </div>

      <div className="bg-altsoft brutal p-3 sm:p-4">
        <video
          data-testid="walkthrough-video"
          src={VIDEO_URL}
          controls
          playsInline
          preload="metadata"
          className="w-full h-auto block brutal-sm"
          style={{ background: "#0A0A0A" }}
        />
      </div>

      <div className="mt-10">
        <h2 className="font-display text-3xl tracking-tighter mb-4">Chapters<span className="text-hot">.</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {STEPS.map((s, i) => (
            <div key={i} data-testid={`chapter-${i}`} className="bg-white brutal-sm p-4 flex items-start gap-3">
              <span className="font-mono-tag text-[11px] uppercase bg-lime brutal-sm px-2 py-1 shrink-0">{s.time}</span>
              <div>
                <p className="font-display text-lg leading-none">{s.title}</p>
                <p className="font-mono-tag text-[10px] uppercase mt-1">{s.note}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
